import { useEffect } from "react";
import PageSelector from "../components/PageSelector";
import ProductForm from "../components/ProductForm";
import ProductTable from "../components/ProductTable";
import usePagedProduct from "../hooks/usePagedProduct";
import useOrdinationStore from "../store/ordinationStore";

function ProductList() {
  const page = useOrdinationStore((state) => state.page);
  const pageSize = useOrdinationStore((state) => state.pageSize);
  const name = useOrdinationStore((state) => state.name);
  const fieldOrder = useOrdinationStore((state) => state.fieldOrder);
  const currentOrder = useOrdinationStore((state) => state.currentOrder);
  const resetOrdination = useOrdinationStore((state) => state.resetOrdination);

  useEffect(() => {
    resetOrdination();
  }, [resetOrdination])

  const {
    data: products,
    isLoading,
    error,
  } = usePagedProduct({ pageSize, page, name, fieldOrder, currentOrder });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading products</div>;

  return (
    <div>
      <h3>Product Form</h3>
      <ProductForm />
      <ProductTable {...products!} />
      <PageSelector {...products!} />
    </div>
  );
}

export default ProductList;
